import React from 'react'
import ReactDOM from 'react-dom'
import BoxesEditor from './BoxesEditor';

window.shop_pokupki_plugin_boxes_editor = (container, props) => {
    ReactDOM.render(<BoxesEditor {...props} />, container);
};